import React from 'react';
import PropTypes from 'prop-types';

import { fetchReclamationExist } from 'store/reclamation/detailsActions';

import { useNavigate } from "react-router-dom";

import ReclamationTooltip from './ReclamationTooltip';



const ReclamationTooltipContainer = ({ expanded }) => {

    const [numeroReclamation, setNumeroReclamation] = React.useState('');
    const [open, setOpen] = React.useState(false);
    const [error, setError] = React.useState('');

    const navigate = useNavigate();

    const handleChange = (event) => {

        let parsed = parseInt(event.target.value.trim(), 10);

        if (isNaN(parsed)) {
            setNumeroReclamation('');
            setError('Veuillez saisir un nombre');
        }
        else {
            setNumeroReclamation(parsed.toString());
            setError('');
        }

    };

    const handleSearch = async () => {
        let exist = await fetchReclamationExist(numeroReclamation);

        if (exist) {
            navigate(`/reclamations/${numeroReclamation}`)
        }
        else {
            setError(`Le dossier après-vente ${numeroReclamation} n'existe pas.`);
        }
    };

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <ReclamationTooltip
            numeroReclamation={numeroReclamation}
            open={open}
            error={error}
            onChange={handleChange}
            onSearch={handleSearch}
            onOpen={handleOpen}
            onClose={handleClose}
            expanded={expanded}
        />
    );
};


ReclamationTooltipContainer.propTypes = {
    expanded: PropTypes.bool.isRequired
};

export default ReclamationTooltipContainer;